/*
Ajaxでデータを取得し、取得したらcallbackに構築した関数に結果を渡す
window.getAjax (
   {
    url: '', //取得先のURL
    param: '', // パラメータ hoge=111&fuga=222
    method: 'get', // get/post
    isCache: true, // 取得先のキャッシュ有効/無効
    responseType: 'document', // 取得タイプ document text json
    callback: function (response) {console.log(response)}, // コールバック関数
  }
)
*/

window.getAjax = function (
  attr = {
    url: '', //取得先のURL
    param: '', // パラメータ hoge=111&fuga=222
    method: 'get', // get/post
    isCache: true, // 取得先のキャッシュ有効/無効
    responseType: 'document', // 取得タイプ document text json
    callback: function (response) {}, // コールバック関数
  }
) {
  const defAttr = {
    url: '', //取得先のURL
    param: '', // パラメータ hoge=111&fuga=222
    method: 'get',
    responseType: 'document', // 取得タイプ document text json
    callback: function (response) {},
    isCache: true,
  }
  attr = { ...defAttr, ...attr } // 引数とデフォルト値をマージ

  let ajax = null

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  if (attr.method === 'post') {
    ajax.open(attr.method, attr.url, true) // GET/POST, URL, 非同期処理
  } else {
    if (attr.param) {
      attr.url += (~attr.url.indexOf('?') ? '&' : '?') + attr.param // パラメータをURLに結合
    }

    // Ajaxと明示するパラメータを付ける
    attr.url += (~attr.url.indexOf('?') ? '&' : '?') + 'ajax=1'
    ajax.open(attr.method, attr.url, true) // GET/POST, URL, 非同期処理
  }

  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  if (!attr.isCache) {
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種1
    ajax.setRequestHeader('Pragma', 'no-cache')
    ajax.setRequestHeader('Cache-Control', 'no-cache')
    ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  }
  if (attr.method === 'post') {
    ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
  }
  ajax.responseType = attr.responseType // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間
  if (attr.method === 'post') {
    ajax.send(attr.param) // POSTリクエスト実行
  } else {
    ajax.send() // GETリクエスト実行
  }

  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }
    attr.callback(ajax.response) // 取得結果を実行
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
    console.log(e)
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
  }
}
